import {
    Settings,
    Support,
    Menu,
    ExitToApp,
    School,
    Layers,
    Clear,
    Home,
    People,
    ArrowRight,
    ArrowLeft,
    FolderOpen,
    BlurOn,
    Balance,
    ChevronRight,
    ChevronLeft,
    Done,
    Subject,
    DoubleArrow,
    InfoOutlined,
    Search,
    Download,
    MiscellaneousServices,
    OpenInNew,
    MoreHoriz,
    Work,
    UploadFile,
    AccountCircle,
    Apartment,
    Token,
    Remove,
    Add,
    SettingsInputComponent,
    Sensors,
    ArrowUpward,
    ArrowDownward,
    ArrowCircleRight,
    ArrowCircleLeft,
    PlayArrow,
    Pause,
    Refresh,
    QuestionMark,
    BugReport,
    Edit,
    Save,
    FastForward,
    Woman,
    Man,
    TravelExplore,
    CheckCircle,
    Cancel,
    FiberManualRecord,
    Warning,
    Handyman,
    Business,
    ListAlt,
    AccountBalance,
    Person,
    FilterAlt,
    Star,
    Visibility,
    VisibilityOff,
    SubdirectoryArrowRight,
    Lock,
    LockOpen,
    CheckBoxOutlineBlank,
    CheckBox,
    LooksOne,
    LooksTwo,
    Looks3,
    Looks4,
    Looks5,
    Looks6,
    ContentCopy,
    CalendarMonth,
    Badge,
    ClearOutlined,
    TaskAlt,
    AccessTime,
    AccountTree,
} from '@mui/icons-material';
import { SvgIcon } from '@mui/material';


const ApplicationIcon = ({ style = {}, className = "" }) => {
    return (
        <SvgIcon>
            <svg style={style} className={`MuiSvgIcon-root MuiSvgIcon-fontSizeMedium css-1umw9bq-MuiSvgIcon-root ${className}`} focusable="false" aria-hidden="true" viewBox="-50 -50 500 500">
                <g>
                    <path fill="currentColor" d="M68.831,99.602h255.814c7.878,0,14.265-6.387,14.265-14.265c0-7.878-6.387-14.265-14.265-14.265H68.831   c-7.878,0-14.265,6.387-14.265,14.265C54.566,93.215,60.953,99.602,68.831,99.602z" />
                    <path fill="currentColor" d="M68.831,160.465h255.814c7.878,0,14.265-6.387,14.265-14.265c0-7.878-6.387-14.265-14.265-14.265H68.831   c-7.878,0-14.265,6.387-14.265,14.265C54.566,154.078,60.953,160.465,68.831,160.465z" />
                    <path fill="currentColor" d="M204.549,192.799H68.831c-7.878,0-14.265,6.387-14.265,14.265c0,7.878,6.387,14.265,14.265,14.265h135.718   c7.878,0,14.265-6.387,14.265-14.265C218.814,199.186,212.427,192.799,204.549,192.799z" />
                    <path fill="currentColor" d="M430.373,409.679l-37.295-73.843l14.431-5.759c3.79-1.513,6.97-5.888,7.24-9.96l1.229-18.516   c0.206-3.102,1.778-7.941,3.434-10.569l9.886-15.702c2.175-3.452,2.175-8.861,0.001-12.314l-9.887-15.702   c-1.654-2.628-3.227-7.469-3.433-10.569l-1.228-18.516c-0.232-3.486-2.6-7.188-5.652-9.132V37.438   c0-15.732-12.798-28.53-28.529-28.53H28.529C12.798,8.908,0,21.706,0,37.438v244.381c0,15.732,12.798,28.529,28.529,28.529h224.396   l0.648,9.77c0.271,4.072,3.45,8.446,7.24,9.959l13.549,5.407l-37.474,74.195c-1.153,2.284-0.844,3.66-0.381,4.412   c0.293,0.477,1.011,1.275,2.523,1.275c0.756,0,1.627-0.204,2.589-0.606l30.697-12.852c0.755-0.316,1.653-0.483,2.597-0.483   c2.255,0,4.553,0.933,5.854,2.374l14.746,16.349c1.229,1.363,2.751,2.114,4.283,2.114c2.022,0,3.836-1.307,4.85-3.494l28.89-62.32   c0.063-0.001,0.125-0.001,0.188-0.002l28.891,62.322c1.014,2.188,2.827,3.494,4.851,3.494c1.531,0,3.053-0.751,4.282-2.115   l14.745-16.347c1.302-1.442,3.6-2.375,5.854-2.375c0.943,0,1.842,0.167,2.597,0.483l30.697,12.852   c0.962,0.402,1.833,0.606,2.589,0.606c1.513,0,2.23-0.799,2.523-1.275C431.217,413.339,431.526,411.963,430.373,409.679z    M28.529,37.438h352.039l0.002,156.56l-11.152-13.417c-2.036-2.449-5.764-4.094-9.275-4.094c-0.855,0-1.673,0.098-2.433,0.291   l-17.998,4.581c-2.867,0.729-8.236,0.729-11.104,0l-17.996-4.581c-0.76-0.193-1.578-0.291-2.433-0.291   c-3.512,0-7.239,1.645-9.275,4.094l-11.866,14.277c-1.984,2.389-6.099,5.379-8.983,6.53l-17.24,6.882   c-3.791,1.513-6.971,5.887-7.241,9.959l-1.229,18.516c-0.205,3.102-1.777,7.941-3.433,10.569l-9.886,15.702   c-2.175,3.452-2.175,8.862,0,12.314l4.085,6.488H28.529V37.438z M334.16,329.825c-33.497,0-60.652-27.154-60.652-60.652   c0-33.498,27.155-60.652,60.652-60.652c33.498,0,60.654,27.154,60.654,60.652C394.815,302.671,367.658,329.825,334.16,329.825z" />
                </g>
            </svg>
        </SvgIcon>
    )
}

const JobIcon = ({ style = {}, className = "" }) => {
    return (
        <SvgIcon>
            <svg style={style} className={`MuiSvgIcon-root MuiSvgIcon-fontSizeMedium css-1umw9bq-MuiSvgIcon-root ${className}`} focusable="false" aria-hidden="true" viewBox="5 0 60 60">
                <g>
                    <path fill="currentColor" d="M30,12V24H28V16.63a23.48,23.48,0,0,0-3.9,1.83A23,23,0,0,0,13,36H58.87c.07.66.11,1.33.13,2A22.8,22.8,0,0,0,44,16.69V24H42V12H36.93v6h-2V12ZM59,38H10a2,2,0,0,0-2,2v2a2,2,0,0,0,2,2H62a2,2,0,0,0,2-2V40a2,2,0,0,0-2-2ZM12.88,38c0-.3,0-.6,0-.9C12.9,37.4,12.89,37.7,12.88,38Zm23-12a4,4,0,1,1-4,4A4,4,0,0,1,35.93,26Z" />
                </g>
            </svg>
        </SvgIcon>
    )
}

export const Icons = {

    Account: Business,
    Gevernment: AccountBalance,
    Business: Business,
    Individual: Person,
    SponsorAccount: Badge,
    Client: Business,
    SubAccount: Apartment,
    User: AccountCircle,
    Application: ApplicationIcon,
    Automation: MiscellaneousServices,
    Folder: FolderOpen,
    Case: Work,
    Enquiry: Balance,
    Report: Subject,
    Person: Man,
    Woman: Woman,
    Man: Man,
    People: People,
    Expert: School,
    Questionnaire: ListAlt,
    Job: Badge,
    Workflow: AccountTree,

    Component: SettingsInputComponent,
    Connection: Sensors,
    Download: Download,
    Settings: Settings,
    Support: Support,
    Exit: ExitToApp,
    Layers: Layers,
    Token: Token,
    Menu: Menu,
    Home: Home,
    Positive: CheckCircle,
    Negative: Cancel,
    Lock: Lock,
    Unlock: LockOpen,
    Copy: ContentCopy,
    Target: CalendarMonth,
    Timer: AccessTime,

    TerritoryFinder: TravelExplore,
    QuestionMark: QuestionMark,
    UploadFile: UploadFile,
    Info: InfoOutlined,
    Filter: FilterAlt,
    More: MoreHoriz,
    Open: OpenInNew,
    Search: Search,
    Minus: Remove,
    Plus: Add,
    Blur: BlurOn,
    Run: PlayArrow,
    Refresh: Refresh,
    Warning: Warning,
    Bug: BugReport,
    Pause: Pause,
    Edit: Edit,
    Save: Save,
    Tick: TaskAlt,
    X: Clear,
    Star: Star,
    Show: Visibility,
    Hide: VisibilityOff,
    XCircle: Cancel,
    Dot: FiberManualRecord,
    Maintenance: Handyman,

    FastForward: FastForward,
    ChevronRight: ChevronRight,
    ChevronLeft: ChevronLeft,
    ArrowDown: ArrowDownward,
    ArrowUp: ArrowUpward,
    DoubleArrow: DoubleArrow,
    ArrowRight: ArrowRight,
    ArrowLeft: ArrowLeft,
    ArrowCircleRight: ArrowCircleRight,
    ArrowCircleLeft: ArrowCircleLeft,
    Subdirectory: SubdirectoryArrowRight,
    Checkbox: CheckBoxOutlineBlank,
    CheckboxChecked: CheckBox,
    One: LooksOne,
    Two: LooksTwo,
    Three: Looks3,
    Four: Looks4,
    Five: Looks5,
    Six: Looks6,
}

export function TypeIcon({ node, style = {} }) {
    switch (node.typeName) {
        case "Aora.Nationality.Data.SponsorNode":
            return <Icons.SponsorAccount className="type-icon" style={style} />
        case "Aora.Platform.Data.AccountNode":
        case "Aora.Nationality.Data.SponsorAccountNode":
            return node.parent?.uid === "ACCOUNT_-1" ? <Icons.Account className="type-icon" style={style} /> : <Icons.Client className="type-icon" style={style} />
        case "Aora.Platform.Data.UserNode":
            return <Icons.User className="type-icon" style={style} />
        case "Aora.Platform.Data.FolderNode":
            return <Icons.Folder className="type-icon" style={style} />
        case "Aora.Platform.Data.CaseNode":
            return <Icons.Case className="type-icon" style={style} />
        case "Aora.Nationality.Data.PersonNode":
            if (node.sex) {
                return node.sex === "F" ? <Icons.Woman className="type-icon" style={style} /> : <Icons.Man className="type-icon" style={style} />
            }
            return <Icons.Person className="type-icon" style={style} />
        case "Aora.Nationality.Data.JobNode":
            return <Icons.Job className="type-icon" style={style} />
        case "Aora.Platform.Data.EnquiryNode":
            return <Icons.Enquiry className="type-icon" style={style} />
        case "Aora.Platform.Data.AutomationNode":
            return <Icons.Application className="type-icon" style={style} />
        case undefined:
        case null:
        default:
            return <Icons.Blur className="type-icon" style={style} />
    }
}